/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Is_HiddenInputs */

const en_tables_rule_sets_is_hidden = /** @type {(inputs: Tables_Rule_Sets_Is_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Is Hidden`)
};

const de_tables_rule_sets_is_hidden = /** @type {(inputs: Tables_Rule_Sets_Is_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is ausgeblendet`)
};

/**
* | output |
* | --- |
* | "Sets Is Hidden" |
*
* @param {Tables_Rule_Sets_Is_HiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_is_hidden = /** @type {((inputs?: Tables_Rule_Sets_Is_HiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Is_HiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_is_hidden(inputs)
	return de_tables_rule_sets_is_hidden(inputs)
});